import { http } from "@/plugins/vuex-rest-auth";
import Vue from "vue";
import VuexRest from "@/plugins/vuex-rest-auth";
import { server } from "../../config";

Vue.use(VuexRest, {
  base: server + "/rest",
});

const SimpleAuth = (Vue) => {
  const state = Vue.observable({
    on: false,
    checking: true,
  });

  Vue.prototype.$auth = {
    login(data) {
      return http.post(`/auth/login`, data).then(({ data }) => {
        window.localStorage.setItem(`token`, data.token);

        return data;
      });
    },
    checkIn: () => {
      const token = window.localStorage.getItem(`token`);
      window.sessionStorage.setItem(`token`, token);

      if (token) {
        return http
          .post(`/auth/check-in?AUTH_TOKEN=${token}`)
          .then(({ data }) => {
            state.checking = false;
            state.on = true;
            return data;
          });
      } else {
        state.checking = false;
        state.on = false;

        return Promise.reject();
      }
    },
    logout: () => {
      const token = window.localStorage.getItem(`token`);

      return http.post(`/auth/logout?AUTH_TOKEN=${token}`).finally(() => {
        state.on = false;
        window.localStorage.removeItem(`token`);
      });
    },
    setStateProp(key, value) {
      state[key] = value;
    },
    get on() {
      return state.on;
    },
    get checking() {
      return state.checking;
    },
  };
};

Vue.use(SimpleAuth);
